import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import FormField from 'screens/Companies/components/FormField';

const PhoneNumberField = () => {
  return (
    <FormField label="Phone Number" htmlFor="phone">
      <FormikInput id="phone" name="phone" />
    </FormField>
  );
};

export default PhoneNumberField;
